import { defineCustomElement } from 'vue'
import App from '../App.vue'

const ensureAssetBase = () => {
  if (typeof window === 'undefined' || typeof document === 'undefined') return
  if (!document.currentScript?.src) return
  const scriptUrl = new URL(document.currentScript.src, window.location.href)
  const base = scriptUrl.pathname.includes('/src/entries/')
    ? `${scriptUrl.origin}/`
    : new URL('./', scriptUrl).toString()
  window.__WIDGET_ASSET_BASE__ = window.__WIDGET_ASSET_BASE__ || {}
  if (typeof window.__WIDGET_ASSET_BASE__ === 'string') return
  window.__WIDGET_ASSET_BASE__.purmo = base
  window.__WIDGET_ASSET_BASE__.default = window.__WIDGET_ASSET_BASE__.default || base
}
ensureAssetBase()
if (typeof window !== 'undefined') {
  window.__WIDGET_MODE__ = true
  if (!window.__WIDGET_API_BASE__ && document.currentScript?.src) {
    const scriptUrl = new URL(document.currentScript.src, window.location.href)
    window.__WIDGET_API_BASE__ = `${scriptUrl.origin}/api`
  }
}

const STYLE_ID = 'purmo-calculator-styles'
const ensureShadowStyles = (shadowRoot) => {
  if (!shadowRoot) return
  if (shadowRoot.querySelector(`style[data-style-id="${STYLE_ID}"]`)) return
  const cssText = window.__WIDGET_CSS__?.[STYLE_ID]
  if (!cssText) return
  const style = document.createElement('style')
  style.setAttribute('data-style-id', STYLE_ID)
  style.textContent = cssText
  shadowRoot.appendChild(style)
}

const PurmoCalculatorElementBase = defineCustomElement(App)
class PurmoCalculatorElement extends PurmoCalculatorElementBase {
  connectedCallback() {
    super.connectedCallback?.()
    ensureShadowStyles(this.shadowRoot)
  }
}

if (!customElements.get('purmo-calculator')) {
  customElements.define('purmo-calculator', PurmoCalculatorElement)
}

const mount = (target, props = {}) => {
  const el = typeof target === 'string' ? document.querySelector(target) : target
  if (!el) return null
  const node = document.createElement('purmo-calculator')
  if (props.market) {
    node.setAttribute('market', props.market)
  }
  if (props.category) {
    node.setAttribute('category', props.category)
  }
  if (props.productId) {
    node.setAttribute('product-id', props.productId)
  }
  if (props.showEudop) {
    node.setAttribute('show-eudop', props.showEudop)
  }
  if (props.hideColumns) {
    node.setAttribute('hide-columns', props.hideColumns)
  }
  if (props.view) {
    node.setAttribute('view', props.view)
  }
  el.appendChild(node)
  return node
}

window.PurmoCalculator = {
  mount,
}
